import React, {useEffect} from 'react';
import Loader from '../Loader';
import {useDispatch, useSelector} from 'react-redux';
import {getCommonLoading, getCommonNotifications} from 'redux/selectors/Common';
import {useSnackbar} from 'notistack';
import {closeSnackbar} from 'redux/actions/Common';
import CloseIcon from './CloseIcon';

let displayed: number[] = [];

const storeDisplayed = (id: number) => {
  displayed = [...displayed, id];
};

const removeDisplayed = (id: number) => {
  displayed = [...displayed.filter((key) => id !== key)];
};

const InfoView: React.FC = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(getCommonLoading);
  const notifications = useSelector(getCommonNotifications);

  const {enqueueSnackbar} = useSnackbar();

  useEffect(() => {
    notifications.forEach(({type, message, key}) => {
      if (displayed.includes(key)) return;

      enqueueSnackbar(message, {
        key,
        variant: type,
        autoHideDuration: type === 'success' ? 3000 : null,
        onExited: () => {
          removeDisplayed(key);
          dispatch(closeSnackbar(key));
        },
        action: (key: any) => <CloseIcon key={key} />,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
      });
      storeDisplayed(key);
    });
  }, [notifications]);

  if (isLoading) {
    return <Loader />;
  }
  return null;
};

export default InfoView;
